import React, {Fragment, memo, useContext, useMemo} from "react";
import classNames from "classnames/bind";
import {useInterSectionObserver} from "hooks";
import {ASSET_LIST_TYPE, ASSET_LIST_TYPE_BY_PROP, MY_ASSET_LIST_TYPE_BY_PROP} from "components/Layout/constants";
import AssetItem from "../AssetItem";
import ListTypeItem from "../ListTypeItem";
import UploadingThumbnail from "../UploadingThumbnail";
import {UploadingAssetContext, UploadProgressContext} from "../UploadProgressProvider";
import styles from "./index.module.scss";
import {useSearchParams} from "react-router-dom";

const cn = classNames.bind(styles);

function ExpandedList({listType = ASSET_LIST_TYPE.IMAGE, data, fetchNextPage, hasNextPage}) {
  const [, loadingRef] = useInterSectionObserver(fetchNextPage, {});

  const uploadingAssetInfo = useContext(UploadingAssetContext);
  const uploadProgress = useContext(UploadProgressContext);
  const displayTotal = data.pages[0].totalCount;
  const appearance = useMemo(
    () => ({
      listType,
      small: true,
    }),
    [listType],
  );

  const [params] = useSearchParams();
  const tab = params.get("tab");
  const type = params.get("type");
  const getListType = topCat => {
    if (tab === "Favorites" || tab === "My") {
      return MY_ASSET_LIST_TYPE_BY_PROP[topCat];
    }
    if (type === "LIGHT") {
      return ASSET_LIST_TYPE.LIST;
    } else {
      return ASSET_LIST_TYPE_BY_PROP[topCat];
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.totalNumber}>
        Total <p>{displayTotal}</p>
      </div>
      <ul className={styles.asset_list}>
        {data?.pages?.map((page, idx) => (
          <Fragment key={idx}>
            {page?.map(asset => (
              <div key={asset.id} className={cn("asset_wrapper", listType)}>
                {getListType(asset.topCategory) === ASSET_LIST_TYPE.LIST && <ListTypeItem data={asset} />}
                {getListType(asset.topCategory) === ASSET_LIST_TYPE.IMAGE && (
                  <AssetItem
                    data={asset}
                    appearance={{
                      listType,
                    }}
                  />
                )}
                {getListType(asset.topCategory) === ASSET_LIST_TYPE.WIDE && <AssetItem data={asset} appearance={appearance} />}
              </div>
            ))}
          </Fragment>
        ))}

        {uploadProgress > 0 && uploadProgress < 100 && (
          <>
            <UploadingThumbnail data={uploadingAssetInfo} uploadProgress={uploadProgress} listType={listType} />
            <div className={styles.space} />
          </>
        )}
        {hasNextPage && <div className={styles.load_more} ref={loadingRef} />}
      </ul>
    </div>
  );
}

export default memo(ExpandedList);
